export default __webpack_public_path__ + "static/media/premiumGiftCard.7d538ac0.png";